<template>
 <Head>
    <title> Create Staff | {{$page.props.appName}}</title>
    <meta name="description" :content="'Create Staff' + $page.props.appName">
  </Head>
  <div class="p-3">
    <div class="bg-gray-100 rounded-md shadow overflow-hidden max-w-3xl p-3">
      <button
        class="bg-black text-white font-bold p-2 ml-6 mt-3"
        @click="$refs.photo.click()"
        v-if="this.url.length == 0"
      >
        Upload Photo
      </button>
      <button
        class="bg-black text-white font-bold p-2 ml-6 mt-3"
        @click="$refs.photo.click()"
        v-else
      >
        Reupload Photo
      </button>
      <input type="file" class="hidden" ref="photo" @change="onFileChange" accept="image/*" />
      <form @submit.prevent="store">
        <img
          :src="url"
          v-if="url.length > 0"
          width="300"
          height="300"
          class="mt-2 px-8"
        />

        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">First Name:</label>
            <input v-model="this.form.first_name" type="text" class="form-input" placeholder="John" />
          </div>
              <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-19" class="form-label">Middlename:</label>
            <input  v-model="this.form.middle_name" id="text-input-19" type="text" class="form-input" placeholder="Henry"/>
          </div>
          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-18" class="form-label">Surname:</label>
            <input v-model="this.form.surname" id="text-input-18" type="text" class="form-input" placeholder="Doe"/>
          </div>
          
          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-21" class="form-label">Site:</label>
            <select class="form-select" v-model="this.form.site">
              <option v-for="site in sites" :key="site.id" :value="site.id"> {{site.site_name}} </option>
            </select>
          </div>
          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-22" class="form-label"
              >Department:</label
            >
            <select class="form-select" v-model="this.form.department">
              <option v-for="department in departments" :key="department.id" :value="department.id"> {{department.department_name}} </option>
            </select>
          </div>
          <div class="pr-6 pb-8 w-full lg:w-1/2" >
            <label for="select-input-23" class="form-label">Phone Number:</label>
              <input type="text" class="form-input" v-model="this.form.phone_number" placeholder="07000000000"/>
          </div>
          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-24" class="form-label">Driving License Number:</label>
            <input type="text" class="form-input" v-model="this.form.driving_license_number" placeholder="GB3232323233"/>
          </div>

          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-24" class="form-label">National Insurance Number:</label>
            <input type="text" class="form-input" v-model="this.form.national_insurance_number" placeholder="JB93339933"/>
          </div>


          
          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-24" class="form-label">Email:</label>
            <input  type="text" class="form-input" v-model="this.form.email" placeholder="john.doe@email.com"/>
          </div>

          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-24" class="form-label">Password:</label>
            <input  type="password" class="form-input" v-model="this.form.password"/>
          </div>

          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-24" class="form-label">Re-enter password:</label>
            <input  type="password" class="form-input" v-model="this.secondpassword"/>
            <p class="text-red-300 text-xs font-semibold" v-if="this.secondpassword != this.form.password"> Please ensure the two passwords are the same!</p>
          </div>



          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-24" class="form-label mr-2">Admin:</label>
            <p class="text-xs">By setting this to true the user will be an Administrator!</p>
            <input  type="checkbox" class="form-checkbox" v-model="this.form.is_admin"/>
          </div>

            <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-24" class="form-label mr-2">Viewer:</label>
            <p class="text-xs">By setting this to true the user will be a viewer!</p>
            <input  type="checkbox" class="form-checkbox" v-model="this.form.is_viewer"/>
          </div>

          <div class="w-full">
            <button type="submit" class="bg-black text-white font-bold p-2 ml-6 mt-3 float-right" :disabled="form.processing">CREATE USER </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import Pagination from "@/Shared/Pagination";
import { Link } from "@inertiajs/inertia-vue3";
import { Head } from '@inertiajs/inertia-vue3'

export default {
  layout: Layout,
  components: { Link, Pagination,Head },
  props: {
    sites: Object,
    departments: Object,
  },
  data() {
    return {
      url: "",
      secondpassword : "",
      form: this.$inertia.form({
        first_name: null,
        middle_name: null,
        surname: null,
        site: this.sites[0].id,
        password: null,
        department: this.departments[0].id,
        phone_number: null,
        driving_license_number: null,
        national_insurance_number: null,
        email: null,
        is_admin: false,
        is_viewer : false,
        photo: null,
      }),
    };
  },
  methods: {
    store() {
      if(this.form.password == this.secondpassword){
      this.form.post("/admin/staff/create");
      }else {
        alert("Both passwords must be the same!")
      }
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.form.photo = file;
      this.url = URL.createObjectURL(file);
    },
  },
};
</script>
     